import { PHONE_NUMBER_COUNTRY } from '@polyseme/utils/string/string-utils';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { z } from 'zod';

const postCodeCedexSchema = z
  .string()
  .refine((value) => /^\d{5}$/.test(value), {
    params: {
      type: 'invalid_post_code',
    },
  });

const phoneNumberSchema = z
  .string()
  .refine(
    (value) =>
      parsePhoneNumberFromString(value, PHONE_NUMBER_COUNTRY)?.isValid(),
    {
      params: {
        type: 'invalid_phone_number',
      },
    }
  );

const leadSchema = z.object({
  city: z.string().optional(),
  contactChannel: z.enum([
    'Web',
    'Téléphone',
    'Courrier',
    'Email',
    'RDV physique',
    'Chat',
    'Banque',
  ]),
  country: z.string().optional(),
  description: z.string().optional(),
  email: z.string().email(),
  firstname: z.string().min(1),
  googleClickId: z.string().optional(),
  lastname: z.string().min(1),
  leadCategory: z.string().min(1),
  leadType: z.string().min(1),
  marketingCampaign: z.string().optional(),
  marketingConsents: z.string().optional(),
  phoneNumber: phoneNumberSchema,
  postalCode: postCodeCedexSchema,
  salutation: z.string().min(1),
  sourcePartner: z.string().min(1),
  streetAddress: z.string().optional(),
});

export const createLeadPayloadSchema = z.array(leadSchema);

export type CreateLeadPayload = z.infer<typeof createLeadPayloadSchema>;

export const createLeadSchema = leadSchema.pick({
  email: true,
  firstname: true,
  googleClickId: true,
  lastname: true,
  phoneNumber: true,
  postalCode: true,
  salutation: true,
  description: true,
  marketingCampaign: true,
  sourcePartner: true,
});

export type CreateLead = z.infer<typeof createLeadSchema>;

export const createLeadResponseSchema = z.object({
  id: z.string(),
  message: z.string(),
});
